import { Card, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Settings } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';

// Renders 3 numbered pairs of (Title, Description) inputs for either
// the "Features" or "Steps" landing-page section.
//
// `keyPrefix` is the field-name stub (`feature` or `step`).
// `labelKey` is the i18n base (`siteSettings.featuresSection` etc.).
export const NumberedSectionCard = ({
  settings, updateField,
  keyPrefix,           // 'feature' | 'step'
  sectionLabelKey,     // 'siteSettings.featuresSection' | 'siteSettings.stepsSection'
  itemLabelKey,        // 'siteSettings.feature' | 'siteSettings.step'
  titleLabelKey,       // 'siteSettings.featureTitle' | 'siteSettings.stepTitle'
  descLabelKey,        // 'siteSettings.featureDesc' | 'siteSettings.stepDesc'
}) => {
  const { t } = useLanguage();

  return (
    <Card className="bg-card border-border">
      <CardContent className="p-6">
        <div className="flex items-center gap-2 mb-6">
          <Settings className="w-5 h-5 text-primary" />
          <h2 className="text-lg font-bold">{t(sectionLabelKey)}</h2>
        </div>

        <div className="space-y-6">
          {[1, 2, 3].map((num) => (
            <div key={num} className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <Label className="text-sm">{t(itemLabelKey)} {num} — {t(titleLabelKey)}</Label>
                <Input
                  value={settings[`${keyPrefix}_${num}_title`] || ''}
                  onChange={(e) => updateField(`${keyPrefix}_${num}_title`, e.target.value)}
                  className="bg-secondary border-border mt-1"
                  data-testid={`${keyPrefix}-${num}-title`}
                />
              </div>
              <div>
                <Label className="text-sm">{t(itemLabelKey)} {num} — {t(descLabelKey)}</Label>
                <Input
                  value={settings[`${keyPrefix}_${num}_desc`] || ''}
                  onChange={(e) => updateField(`${keyPrefix}_${num}_desc`, e.target.value)}
                  className="bg-secondary border-border mt-1"
                  data-testid={`${keyPrefix}-${num}-desc`}
                />
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
